import { render, staticRenderFns } from "./jtbianji.vue?vue&type=template&id=54aa6c6c&scoped=true&"
import script from "./jtbianji.vue?vue&type=script&lang=js&"
export * from "./jtbianji.vue?vue&type=script&lang=js&"
import style0 from "./jtbianji.vue?vue&type=style&index=0&id=54aa6c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa6c6c",
  null
  
)

export default component.exports